import Joi from '@hapi/joi'

export const EstateComparisonReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.required": `From date required`
    }),
    toDate: Joi.string().invalid("").required().label("To Date").messages({
        "any.required": `To date required`
    }),
}